import React, { useEffect, useState } from 'react';
import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom';
import authService from '../../utils/authService';
import '../../styles/AdminLayout.css';

const AdminLayout = () => {
  const [user, setUser] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check authentication
    const checkAuth = async () => {
      const isAuth = await authService.verifyToken();
      if (!isAuth) {
        navigate('/admin/login');
      } else {
        setUser(authService.getCurrentUser());
      }
    };

    checkAuth();
  }, [navigate]);

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      authService.logout();
      navigate('/admin/login');
    }
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  if (!user) {
    return <div className="admin-loading">Loading...</div>;
  }

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <div className="admin-sidebar-header">
          <h2>🔮 Admin</h2>
          <button className="sidebar-toggle" onClick={toggleSidebar}>
            {sidebarOpen ? '◀' : '▶'}
          </button>
        </div>

        <nav className="admin-nav">
          <Link to="/admin/dashboard" className={isActive('/admin/dashboard')}>
            <span className="nav-icon">📊</span>
            {sidebarOpen && <span>Dashboard</span>}
          </Link>

          <Link to="/admin/home-content" className={isActive('/admin/home-content')}>
            <span className="nav-icon">🏠</span>
            {sidebarOpen && <span>Home Page</span>}
          </Link>

          <Link to="/admin/services" className={isActive('/admin/services')}>
            <span className="nav-icon">🔮</span>
            {sidebarOpen && <span>Services</span>}
          </Link>

          <Link to="/admin/bookings" className={isActive('/admin/bookings')}>
            <span className="nav-icon">📅</span>
            {sidebarOpen && <span>Bookings</span>}
          </Link>

          <Link to="/admin/blog" className={location.pathname.includes('/admin/blog') ? 'active' : ''}>
            <span className="nav-icon">📝</span>
            {sidebarOpen && <span>Blog</span>}
          </Link>

          <Link to="/admin/settings" className={isActive('/admin/settings')}>
            <span className="nav-icon">⚙️</span>
            {sidebarOpen && <span>Settings</span>}
          </Link>
        </nav>

        <div className="admin-sidebar-footer">
          <div className="admin-user-info">
            {sidebarOpen && (
              <>
                <p className="user-name">{user.name}</p>
                <p className="user-email">{user.email}</p>
              </>
            )}
          </div>
          <button onClick={handleLogout} className="logout-button">
            <span className="nav-icon">🚪</span>
            {sidebarOpen && <span>Logout</span>}
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className={`admin-main ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <div className="admin-topbar">
          <button className="mobile-menu-toggle" onClick={toggleSidebar}>
            ☰
          </button>
          <div className="admin-topbar-right">
            <a href="/" target="_blank" rel="noopener noreferrer" className="view-site-link">
              View Site →
            </a>
          </div>
        </div>

        <div className="admin-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
